import { atom } from "recoil";

export const notificationsEditModalStore = atom({
	key: "notificationsEditModalStore",
	default: {
		show: false,
		editId: null,
		formData: {
			image: "",
			localName: "",
			buttonType: "",
			buttonLink: "",
			buttonLinkType: "",
			buttonText: "",
			linkType: "",
			link: "",
			title: "",
			titleType: "",
			description: "",
			descriptionType: "",
			priority: 1,
			active: true,
			from: "",
			to: "",
			type: "default",
			tags: [],

			cohort: {
				dateRegistrationFrom: "",
				dateRegistrationTo: "",
				dateDepositFrom: "",
				dateDepositTo: "",
				depositCount: "",
				depositType: "",
				emailExists: null,
				emailVerify: null,
				tgExists: null,
				vipLvl: "",
				phoneExists: null,
			},

			showSettings: [
				{
					page: "",
					seconds: 5,
				},
			],
		},
	},
});
